export const isEmptyObject = (object: Record<string, unknown>) =>
    !object || Object.keys(object).length === 0;
